<template>
  <div>
    <div class="table">
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Punctuality Report available."
      >
      </el-table>
      <el-table
        v-else
        style="margin-bottom: 20px"
        :data="reports"
        width="100%"
        v-loading="loading"
        empty-text="No Punctuality Report available."
        class="colored-head"
      >
        <el-table-column prop="employee_details" label="Name" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="employee_details" label="Pin" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.pin }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="custom_employee_id"
          label="Custom Id"
          width="200"
          v-if="'custom_employee_id' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.custom_employee_id || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Grade"
          width="200"
          v-if="'employee_grade' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_grade || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Type"
          width="200"
          v-if="'employee_type' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_type || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Employee Category"
          width="200"
          v-if="'employee_category' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.employee_category || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Mobile Number"
          width="200"
          v-if="'mobile_number' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.mobile_number || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Email"
          width="150"
          v-if="'email' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.email || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_details"
          label="Department"
          width="150"
          v-if="'department' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.department || "NA" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="employee_details"
          label="Branch"
          width="150"
          v-if="'branch' in reports[0].employee_details"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.employee_details.branch || "NA" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="average_clocktime"
          label="AVERAGE CLOCK TIME"
          width="200"
        ></el-table-column>
        <el-table-column
          sortable
          prop="num_punctuality"
          label="No. OF PUNCTUALITY"
          width="200"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],
};
</script>
